/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PagingAndSortingRequestParam } from './PagingAndSortingRequestParam';
import type { VitalSignsViewFilter } from './VitalSignsViewFilter';

export type VitalSignsViewRequest = {
    filter?: VitalSignsViewFilter;
    pagingAndSortingRequestParam?: PagingAndSortingRequestParam;
    exposeType?: VitalSignsViewRequest.exposeType;
}

export namespace VitalSignsViewRequest {

    export enum exposeType {
        EXCEL = 'EXCEL',
        PDF = 'PDF',
        WORD = 'WORD',
        HTML = 'HTML',
        XML = 'XML',
        JSON = 'JSON',
        CSV = 'CSV',
    }


}
